import { render, staticRenderFns } from "./fee.vue?vue&type=template&id=74401b6d&scoped=true"
import script from "./fee.vue?vue&type=script&lang=ts"
export * from "./fee.vue?vue&type=script&lang=ts"
import style0 from "./fee.vue?vue&type=style&index=0&id=74401b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74401b6d",
  null
  
)

export default component.exports